"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFulfillmentOrderShippedMockData = exports.buildFulfillmentReadyForPickupMockData = exports.FROALA_ORDER_SHIPPED_BODY = exports.FROALA_READY_FOR_PICKUP_BODY = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const icons_1 = require("../icons");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const FROALA_PARAGRAPH_STYLE = "width:100%;margin:0px;box-sizing:inherit;color:rgb(0, 0, 0);line-height:1.5;";
const MOCK_ORDER_DETAILS_HTML = `<ul style="margin:0px;padding-left:18px;box-sizing:inherit;">
<li style="${FROALA_PARAGRAPH_STYLE}">Team Hoodie — Navy, M × 1 — $45.00</li>
<li style="${FROALA_PARAGRAPH_STYLE}">Water Bottle × 2 — $24.00</li>
</ul>`;
exports.FROALA_READY_FOR_PICKUP_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><br></p>
<p style="${FROALA_PARAGRAPH_STYLE}">Your order is ready for pickup! Here are the details:</p>
${MOCK_ORDER_DETAILS_HTML}
<p style="${FROALA_PARAGRAPH_STYLE}">📍 <strong>Pickup address:</strong><br>123 Main Street West, St. Albans VT 05478.</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><br></p>
<p style="${FROALA_PARAGRAPH_STYLE}">📝 <strong>Pickup instructions:</strong><br>Please pick-up at our offices on weekdays from 9:00 AM to 5:00 PM.</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><br></p>
<p style="${FROALA_PARAGRAPH_STYLE}">Thank you for supporting Riverside Youth Soccer!</p>`;
exports.FROALA_ORDER_SHIPPED_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><br></p>
<p style="${FROALA_PARAGRAPH_STYLE}">Your order has been shipped! Here are the details:</p>
${MOCK_ORDER_DETAILS_HTML}
<p style="${FROALA_PARAGRAPH_STYLE}">Thank you for supporting Riverside Youth Soccer!</p>`;
const resolveBase = ({ color, isDarkMode, locale = "en" }) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    return { labels, theme, iconZeffyLogo, lang: locale };
};
const buildFulfillmentReadyForPickupMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const { orgName, message = exports.FROALA_READY_FOR_PICKUP_BODY } = input;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        subject: "Your order is ready for pick-up",
        orgName: orgName || "Bright Futures Foundation",
        message,
    };
};
exports.buildFulfillmentReadyForPickupMockData = buildFulfillmentReadyForPickupMockData;
const buildFulfillmentOrderShippedMockData = (input) => {
    const { labels, theme, iconZeffyLogo, lang } = resolveBase(input);
    const { orgName, message = exports.FROALA_ORDER_SHIPPED_BODY } = input;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang,
        subject: "Your order has shipped",
        orgName: orgName || "Bright Futures Foundation",
        message,
    };
};
exports.buildFulfillmentOrderShippedMockData = buildFulfillmentOrderShippedMockData;
